exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-title[data-v-6b003d2d] {\n  position: relative;\n}\n[data-v-6b003d2d] .dialog-box {\n  border-radius: 10px;\n  padding: 0;\n}\n[data-v-6b003d2d] .dialog-box > .el-dialog__header {\n  padding: 0;\n}\n.info-bg[data-v-6b003d2d] {\n  width: 100%;\n}\n.info-time[data-v-6b003d2d] {\n  position: absolute;\n  left: 7.5%;\n  bottom: 10%;\n  font-size: 14px;\n  color: #666666;\n}", ""]);

// exports
